export default "__VITE_ASSET__CUnKqhNx__"